export const TranslateFr = {
    hello: 'Salut'
};